import React, { FC } from 'react'

// MUI
import { CardMedia, Container, Grid } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'

// CONSTANTS
import { CONSTANTS } from '@/constants'

// UI
import { PaddTwentyFour, TypographySpan } from '@/ui'
import { AbtHeroDiv, CustomLI, CustomUL, SectionHeadH2, SectionParaText } from './styles'

// Data
import { HeroSecData } from './data'

const AboutHeroSection: FC = () => {
  return (
    <AbtHeroDiv>
      <Container maxWidth="xl">
        <PaddTwentyFour>
          <Grid container justifyContent="space-between" spacing={4}>
            <Grid item xs={12} sm={6} md={6}>
              <SectionHeadH2>We are {CONSTANTS.APP_NAME}</SectionHeadH2>

              <br />

              <SectionParaText>
                {CONSTANTS.APP_NAME} is a furniture-producing company which items can be characterized as unique, non-conformist and authentic - never boring and always full of imagination and
                inspiration.
              </SectionParaText>

              <SectionParaText>
                We are a team of professional and skilled experts in all domestic spheres. We offer a wide range of services and at the same time we are always glad to help you with any unconventional
                household needs:
              </SectionParaText>

              <CustomUL>
                {HeroSecData.map((data, idx) => {
                  return (
                    <CustomLI key={idx}>
                      <CheckIcon />

                      <TypographySpan className="text">{data.title}</TypographySpan>
                    </CustomLI>
                  )
                })}
              </CustomUL>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <CardMedia
                component="img"
                src="/pages/about-page/hero-section/hero_section_img.webp"
                srcSet="/pages/about-page/hero-section/hero_section_img.webp"
                alt={`About ${CONSTANTS.APP_NAME}`}
                title={`About ${CONSTANTS.APP_NAME}`}
              />
            </Grid>
          </Grid>
        </PaddTwentyFour>
      </Container>
    </AbtHeroDiv>
  )
}

export default AboutHeroSection
